import Vue from "vue";
import Vuetify, {
    VApp,
    VAppBar,
    VAppBarNavIcon,
    VProgressLinear,
    VSpacer,
    VToolbar,
    VSparkline,
    VToolbarTitle,
    VImg,
    VRow,
    VCol,
    VMenu,
    VList,
    VListItem,
    VListItemTitle,
    VListItemIcon,
    VListItemContent,
    VListItemAvatar,
    VListItemSubtitle,
    VListItemGroup,
    VListItemAction,
    VBtn,
    VForm,
    VIcon,
    VMain,
    VContainer,
    VCarousel,
    VCarouselItem,
    VSheet,
    VNavigationDrawer,
    VDivider,
    VSlideYTransition,
    VCard,
    VCardTitle,
    VCardText,
    VCardActions,
    VCardSubtitle,
    VChip,
    VHover,
    VFooter,
    VTextarea,
    VTextField,
    VTabs,
    VContent,
    VTabsSlider,
    VTab,
    VTabsItems,
    VTabItem,
    VCheckbox,
    VSelect,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
    VDialog,
    VBtnToggle,
    VListGroup,
    VAvatar,
    VStepper,
    VStepperStep,
    VStepperContent,
    VOverflowBtn,
    VFileInput,
    VAlert,
    VSimpleTable,
    VDataTable,
    VBreadcrumbs,
    VSlideItem,
    VSlideGroup,
    VLayout,
    VFlex,
    VRadio,
    VRadioGroup,
    VAutocomplete,
    VSwitch,
} from 'vuetify/lib';

import {Ripple, Intersect, Scroll, Resize, ClickOutside} from 'vuetify/lib/directives'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify, {
    icons: {
        iconfont: 'mdi',
    },
    components: {
        VApp,
        VAppBar,
        VAppBarNavIcon,
        VProgressLinear,
        VSpacer,
        VToolbar,
        VToolbarTitle,
        VImg,
        VRow,
        VCol,
        VMenu,
        VList,
        VListItem,
        VListItemTitle,
        VListItemIcon,
        VListItemContent,
        VListItemAvatar,
        VListItemSubtitle,
        VListItemGroup,
        VListItemAction,
        VBtn,
        VForm,
        VIcon,
        VMain,
        VContainer,
        VCarousel,
        VCarouselItem,
        VSparkline,
        VSheet,
        VNavigationDrawer,
        VDivider,
        VSlideYTransition,
        VCard,
        VCardTitle,
        VCardText,
        VCardActions,
        VCardSubtitle,
        VChip,
        VHover,
        VFooter,
        VTextarea,
        VTextField,
        VTabs,
        VContent,
        VTabsSlider,
        VTab,
        VTabsItems,
        VTabItem,
        VCheckbox,
        VSelect,
        VExpansionPanels,
        VExpansionPanel,
        VExpansionPanelHeader,
        VExpansionPanelContent,
        VDialog,
        VBtnToggle,
        VListGroup,
        VAvatar,
        VStepper,
        VStepperStep,
        VStepperContent,
        VOverflowBtn,
        VFileInput,
        VAlert,
        VSimpleTable,
        VDataTable,
        VBreadcrumbs,
        VSlideItem,
        VSlideGroup,
        VLayout,
        VFlex,
        VRadio,
        VRadioGroup,
        VAutocomplete,
        VSwitch,
    },
    directives: {
        Ripple, Intersect, Scroll, Resize, ClickOutside
    },
});


const opts = {
    breakpoint: {scrollbarWidth: 5},
    rtl: true,
    theme: {
        dark: false,
        options: {customProperties: true},
        themes: {
            light: {
                primary: "#001554",
                secondary: "#595959",
                accent: "#00796B",
                third: "#c30000",
                error: "#fd397a",
                info: "#5578eb",
                success: "#0abb87",
                warning: "#ffb822",
                orange: "#e87520",
            },
            dark: {
                primary: '#5064e6',
                pink: '#FF5370',
            }
        }
    },
};

export default new Vuetify(opts)